﻿1<template>

    <header v-if="!EmbedCheck() && getHeroImage()!=''" class="header">
        <header_menu></header_menu>
        <hero :title="getSearchTitle()" :subtitle="getSearchHeader()" :hero_image="getHeroImage()"></hero>
    </header>

    <main class="main w-full h-42 ">

        <searchfilter v-if="!EmbedCheck() && !useFilterPanel"
                      v-on:onFilterChange="onFilterChange"
                      v-on:onTagChange="onTagChanges"
                      v-on:onSearchChange="onSearchChanges"
                      v-on:onStrictFilterChange="onStrictFilterChange"
                      @tourSelected="Tour_Selected"
                      :show_cart="getHeroImage() == ''"
                      :tours="includedTours(product_search?.products)"></searchfilter>

        <div v-if="!EmbedCheck()" class="lg:flex lg:items-start lg:gap-6">
            <tour_filter_panel v-if="useFilterPanel"
                               ref="filter_panel"
                               :tours="filteredTours"
                               @filtered="onFilterPanelChange"
                               @chipsChange="onFilterChipsChange"></tour_filter_panel>
            <cart_preview_button v-if="useFilterPanel && getHeroImage() == ''"></cart_preview_button>

            <div id="product" class="flex-1 min-w-0 row searchBackground mt-0 pt-0">
                <!-- with the side filter panel the filter pills (VITE_DEFAULT_FILTER_MULTI_SELECT tags) sit at the top of the
                     results column, so the panel keeps the full column height; without it they're in the toolbar (searchfilter.vue) -->
                <filter_buttons v-if="useFilterPanel" class="ts-results-pills" v-on:onTagChange="onTagChanges"></filter_buttons>

                <div class="ts-results-head" :hidden="loading_search">
                    <div v-if="$route.query.filterto">
                        <div v-if="filterMessage != null && filterMessage != ''">
                            <h2 class="ts-results-title" :hidden="product_search?.products?.length == 0">{{filterMessage}}</h2>
                        </div>
                        <div v-else>
                            <h2 v-if="products_to_display.products?.length == 1" class="ts-results-title" :hidden="product_search?.products?.length == 0">Displaying 1 tour</h2>
                            <h2 v-else class="ts-results-title" :hidden="product_search?.products?.length == 0">Displaying {{ products_to_display.products?.length }} tours</h2>
                        </div>
                        <button @click="showAllTours()" type="button" class="ts-see-all">See all tours</button>
                    </div>
                    <h2 v-else class="ts-results-title" :hidden="(products_to_display.products?.length ?? 0) == 0">{{products_to_display.products.length}} {{products_to_display.products.length == 1 ? 'tour' : 'tours'}} available</h2>

                    <!-- side panel filters as removable pills. Dates: a Dates button until dates are set, then the dates with
                         previous/next day; both open the calendar slide-out (kept in sync with the panel's Travel Dates) -->
                    <div v-if="useFilterPanel" class="ts-active-filters">
                        <button v-if="!filter_date_chip" type="button" class="ts-tool-btn" @click="Open_Dates_Calendar()">
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="3" y="4" width="18" height="18" rx="2" /><path d="M16 2v4M8 2v4M3 10h18" /></svg>
                            Dates
                        </button>
                        <div v-if="filter_date_chip" class="ts-date-chip">
                            <div class="flex items-center" :class="{ 'ts-date-stepper': filter_date_chip.canStep }">
                                <button v-if="filter_date_chip.canStep" type="button" class="ts-step-btn" aria-label="Previous day" :disabled="!filter_date_chip.canStepBack" @click="Step_Filter_Dates(-1)">
                                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.25" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M15 18l-6-6 6-6" /></svg>
                                </button>
                                <button type="button" class="ts-tool-btn has-value" @click="Open_Dates_Calendar()">
                                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="3" y="4" width="18" height="18" rx="2" /><path d="M16 2v4M8 2v4M3 10h18" /></svg>
                                    {{ filter_date_chip.label }}
                                </button>
                                <button v-if="filter_date_chip.canStep" type="button" class="ts-step-btn" aria-label="Next day" @click="Step_Filter_Dates(1)">
                                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.25" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 18l6-6-6-6" /></svg>
                                </button>
                            </div>
                            <button type="button" class="ts-chip-remove" aria-label="Remove travel dates" @click="Remove_Filter_Chip({ section: 'dates' })">
                                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" aria-hidden="true"><path d="M18 6L6 18M6 6l12 12" /></svg>
                            </button>
                        </div>
                        <button v-for="chip in filter_chips" :key="chip.section + ':' + (chip.value ?? '')" type="button" class="ts-pill is-active is-removable" :aria-label="'Remove filter ' + chip.label" @click="Remove_Filter_Chip(chip)">
                            {{ chip.label }}
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" aria-hidden="true"><path d="M18 6L6 18M6 6l12 12" /></svg>
                        </button>
                        <button v-if="filter_chips.length + (filter_date_chip ? 1 : 0) > 1" type="button" class="ts-clear-filters" @click="Clear_Filter_Chips()">Clear all</button>
                    </div>
                    <div v-if="!loading_search && (products_to_display.products?.length ?? 0) == 0 && (in_cart.products?.length ?? 0) == 0" class="ts-empty">
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="11" cy="11" r="7" /><path d="M21 21l-4.3-4.3" /></svg>
                        <h2 class="ts-results-title">Sorry, none of our tours match your search</h2>
                        <p>Try different dates, or clear some of the filters.</p>
                    </div>
                    <!-- filter pills now sit in the toolbar next to Dates (searchfilter.vue) -->

                    <!-- <button v-if="isHEXorHAG()"
                    type="button"
                    class="ml-auto shrink-0 button button-pink-book mr-4"
                    v-on:click="open_gift_card()"
                    :disabled="gift_card_loading"
                    >
                        <span v-if="gift_card_loading">
                            <svg class="animate-spin h-4 w-4 inline" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 512 512">
                                <path fill="currentColor" d="M440.65 12.57l4 82.77A247.16 247.16 0 0 0 255.83 8C134.73 8 33.91 94.92 12.29 209.82A12 12 0 0 0 24.09 224h49.05a12 12 0 0 0 11.67-9.26 175.91 175.91 0 0 1 317-56.94l-101.46-4.86a12 12 0 0 0-12.57 12v47.41a12 12 0 0 0 12 12H500a12 12 0 0 0 12-12V12a12 12 0 0 0-12-12h-47.37a12 12 0 0 0-11.98 12.57zM255.83 432a175.61 175.61 0 0 1-146-77.8l101.8 4.87a12 12 0 0 0 12.57-12v-47.4a12 12 0 0 0-12-12H12a12 12 0 0 0-12 12V500a12 12 0 0 0 12 12h47.35a12 12 0 0 0 12-12.6l-4.15-82.57A247.17 247.17 0 0 0 255.83 504c121.11 0 221.93-86.92 243.55-201.82a12 12 0 0 0-11.8-14.18h-49.05a12 12 0 0 0-11.67 9.26A175.86 175.86 0 0 1 255.83 432z"></path>
                            </svg>
                        </span>
                        <span v-else class="flex items-center gap-2">
                            <svg class="h-4 w-4 shrink-0" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M21 11V9C21 7.89543 20.1046 7 19 7H17M21 11H3M21 11H20V18C20 19.1046 19.1046 20 18 20H12M3 11V9C3 7.89543 3.89543 7 5 7H7M3 11V11C3.55228 11 4 11.4477 4 12V18C4 19.1046 4.89543 20 6 20H12M12 7V20M12 7H17M12 7H7M12 7V6M17 7L17.3158 5.73692C17.6633 4.3467 16.6119 3 15.1788 3V3C14.4424 3 13.7546 3.36807 13.3461 3.98086L12 6M7 7L6.68423 5.73692C6.33668 4.3467 7.38815 3 8.82116 3V3C9.55763 3 10.2454 3.36807 10.6539 3.98086L12 6" stroke="#ffffff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                            Gift Cards
                        </span>
                    </button> -->
                </div>
                <div v-if="loading_search" class="ts-loading" role="status" aria-live="polite">
                    <p class="ts-loading-label">
                        <svg class="ts-spinner" viewBox="0 0 24 24" fill="none" aria-hidden="true"><circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="3" opacity="0.25" /><path d="M22 12a10 10 0 0 0-10-10" stroke="currentColor" stroke-width="3" stroke-linecap="round" /></svg>
                        {{getLoadingText()}}
                    </p>
                    <div class="ts-grid" aria-hidden="true">
                        <div v-for="n in 6" :key="n" class="tc-card tc-skeleton">
                            <div class="tc-skeleton-media"></div>
                            <div class="tc-body"><span></span><span></span><span></span></div>
                        </div>
                    </div>
                </div>
                <div v-else class="ts-grid">
                    <template v-if="CartCount() > 0">
                        <tour_card v-for="tour_item in in_cart.products" :key="'cart-' + tour_item.tour_id" :InCart="true" :tour_details=tour_item></tour_card>
                    </template>
                    <tour_card v-for="tour_item in products_to_display.products" :key="tour_item.tour_id" :tour_details=tour_item @bookTour="onBookTour"></tour_card>
                </div>
                <div class="slideout" :hidden="isHidden" :active="!isHidden" style="z-index: 201 !important;">
                    <div class="slideout-inner w-full h-full fixed overflow-auto bg-white">
                        <button class="td-back" @click="Reset_Basket()">
                            <svg class="w-4 h-4" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M15 19l-7-7 7-7" />
                            </svg>
                            All Tours
                        </button>
                        <div class="slideout-content w-full h-full p-4 box-border rounded-lg">
                            <tour_details :trip_index=trip_index ref="tour_details" @Add_To_Cart="Add_To_Cart"></tour_details>
                        </div>
                    </div>
                    <div class="slideout-bg" @click="Reset_Basket()"></div>
                </div>
            </div>
        </div>

        <!-- Embedded view -->
        <div v-else id="product" class="row searchBackground">
            <div class="ts-grid is-single">
                <tour_card v-if="embeddedTour.tour_id !== 'NUL'" :tour_details="embeddedTour" @bookTour="onBookTour" />
            </div>
            <div class="slideout" :hidden="isHidden" :active="!isHidden"
                 style="z-index: 201 !important;">
                <div>
                    <div class="slideout-content embed">
                        <embedded_calendar :trip_index=trip_index ref="tour_details" @Add_To_Cart="Add_To_Cart"></embedded_calendar>
                    </div>
                </div>
                <div class="slideout-bg" @click="Reset_Basket()"></div>
            </div>
        </div>
    </main>

    <!-- calendar slide-out for the filter row's Dates button (side panel mode); the same calendar as the toolbar's Dates
         button (searchfilter.vue), but its dates go to the side panel's Travel Dates. Teleported so it sits above the sticky nav. -->
    <Teleport to="body">
        <div v-if="useFilterPanel && dates_calendar_created" class="slideout" :class="{'active': dates_calendar_open, 'hidden': !dates_calendar_open}">
            <div class="slideout-inner sc-slideout">
                <button class="close no-bg" aria-label="Close" @click="dates_calendar_open = false"></button>

                <search_calendar ref="dates_calendar"
                                 @tourSelected="Tour_Selected"
                                 @onSearchChange="onDatesCalendarChange"
                                 @datePicked="onDatesCalendarPicked"></search_calendar>
            </div>

            <div class="slideout-bg" @click="dates_calendar_open = false"></div>
        </div>
    </Teleport>

    <footer_item v-if="!EmbedCheck() && getHeroImage()!=''"></footer_item>

</template>

<script lang="ts" src="./1_search.ts"></script>